import axios from 'axios'

export default function uploadToS3(url: string, file: File) {
  return axios.put(url, file, {
    headers: {
      'Content-Type': '', // Throws 403 if we don't clear this
    },
  })
}
